import { render, staticRenderFns } from "./InfoListValue.vue?vue&type=template&id=1e66493e"
var script = {}
import style0 from "./InfoListValue.vue?vue&type=style&index=0&id=1e66493e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports